import React from 'react';
import Home1 from './1';
// import Home2 from './2';
import Home3 from './3';
// import Home4 from './4';
import Home5 from './5';
import Home6 from './6';

function Home() {
  return (
    <>
      <Home1 />
      {/* <Home2 /> */}
      <Home3 />
      {/* <Home4 /> */}
      <Home5 />
      {/* <Home6 /> */}
    </>
  );
}

export default Home;
